<template>
  <section class="dan_alix_celebrity">
    <div class="dan_alix_style_grid">
      <!-- left Side -->
      <div class="dan_alix_show grid">
        <p class="dan_alix_show_content" v-html="shopifyData.leftHeading" />
        <div class="link_wrapper">
          <img
            v-lazy="shopifyData.imgUrl.src"
            :src-placeholder="shopifyData.imgUrl.placeholder"
            :alt="shopifyData.imgUrl.alt || 'Left Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Left Image"
            width=""
            height=""
            @click="showCard"
          />
          <div class="product_card_wrapper modify-slider">
            <swiper
              :class="{ active: isactive.includes(key) }"
              :modules="modules"
              :slides-per-view="'1'"
              :mousewheel="{ invert: false, releaseOnEdges: true }"
              :navigation="true"
            >
              <swiper-slide v-for="(product, index) in shopifyData.productData" :key="index">
                <productPopup :product-data="product" @close="toggle_selection_for(key)" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <!-- Right Side -->
      <div class="dan_alix_show_bucket grid">
        <div class="link_wrapper">
          <img
            v-lazy="shopifyData.imgRightUrl.src"
            :src-placeholder="shopifyData.imgRightUrl.placeholder"
            :alt="shopifyData.imgRightUrl.alt || 'Right Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Right Image"
            width=""
            height=""
            @click="showCard"
          />
          <div class="product_card_wrapper modify-slider">
            <swiper
              :class="{ active: isactive.includes(key) }"
              :modules="modules"
              :slides-per-view="'1'"
              :mousewheel="{ invert: false, releaseOnEdges: true }"
              :navigation="true"
            >
              <swiper-slide v-for="(product, index) in shopifyData.productData2" :key="index">
                <productPopup :product-data="product" @close="toggle_selection_for(key)" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <h3 class="dan_alix_show_content heading-2" v-html="shopifyData.rightHeading" />
        <p class="dan_alix_show_text" v-html="shopifyData.rightText" />
      </div>
    </div>
  </section>
</template>

<script>
// Producct Popup Component Import
import productPopup from '../product-popup.vue';
// Slider Import
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
export default {
  components: {
    productPopup,
    Swiper,
    SwiperSlide,
  },

  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isactive: [],
    };
  },
  methods: {
    toggle_selection_for(key) {
      if (window.innerWidth <= 768) {
        if (this.isactive.includes(key)) {
          this.isactive = this.isactive.filter((item) => item !== key);
        } else {
          this.isactive.push(key);
        }
      }
    },
    showCard(e) {
      if (window.innerWidth <= 768) {
        e.target.nextElementSibling.classList.add('show');
      }
    },
  },
};
</script>

<style scoped>
.product_info_card {
  position: static;
  transform: unset;
}
img {
  display: block;
  max-width: 100%;
}
.dan_alix_style_grid {
  display: flex;
  gap: 15px;
  margin: 100px 8% 70px;
  justify-content: space-between;
}
.grid {
  width: calc(50% - 30px);
}
.dan_alix_show_content {
  font-family: 'Big Caslon', sans-serif;
  font-size: 48px;
  line-height: 1;
  margin-bottom: 15px;
  font-weight: 500;
}
.heading-2 {
  margin-top: 30px;
  /* line-height: 30px; */
}
.dan_alix_show_text {
  font-family: 'adobe-caslon-pro', sans-serif;
  font-size: 14px;
  line-height: 18px;
  margin-top: 15px;
}

@media only screen and (max-width: 768px) {
  .dan_alix_style_grid {
    flex-direction: column;
    margin: 60px 8% 70px;
  }
  .grid {
    width: 100%;
  }
  .heading-2 {
    line-height: 40px;
  }
  .dan_alix_show_text {
    margin-top: 0;
  }
  .dan_alix_show_content {
    margin-bottom: 15px;
  }
}
</style>
